import { t } from 'app//core/internationalization';

export const i18n = {
  queryLibrary: t('explore.rich-history.query-library', 'Query library'),
  queryHistory: t('explore.rich-history.query-history', 'Query history'),
};
